import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './mobile.css';

/* Google Fonts */
const link = document.createElement('link');
link.href = 'https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700&family=DM+Sans:wght@400;500;600&display=swap';
link.rel  = 'stylesheet';
document.head.appendChild(link);

/* Global reset */
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'DM Sans', sans-serif; background: #f8f9fc; color: #0f1233; -webkit-font-smoothing: antialiased; }
  input, select, textarea, button { font-family: inherit; }
  a { color: inherit; }
  @media (max-width: 768px) {
    .hide-mobile { display: none !important; }
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
